"use strict";

/* -------------------------------------------------------------------------

	PUNITED.anect

	トップページのスクリプトを定義
	※jQuery必須
	Potential United inc.

------------------------------------------------------------------------- */
// グローバル名前空間定義
var PUNITED;
if (!PUNITED) PUNITED = {};
if (!PUNITED.anect) PUNITED.anect = {};

(function () {
  // グローバル名前空間オブジェクトをローカルオブジェクトに置き換え
  var ns = PUNITED.anect;
  /* -----------------------------------------------------
  
  ----------------------------------------------------- */
})();

$(function () {
  PUNITED.utils.headLine({
    width: 1939.51,
    height: 130.569,
    d: [{
      command: 'M',
      points: [[-13670.6, -11619.008]]
    }, {
      command: 'c',
      points: [[-110.166, -65.755], [-416.506, 35.457], [-611.859, 15.373]]
    }, {
      command: 's',
      points: [[-178.57, -70.389], [-589.508, -31.219], [-737.25, -94.75], [-737.25, -94.75]]
    }],
    translate: [15609.599, 11730.528]
  }, {
    width: 472.594,
    height: 33.226,
    d: [{
      command: 'M',
      points: [[-15137.518, -11702.693]]
    }, {
      command: 'c',
      points: [[-4.155, -2.479], [-9.457, -3.983], [-15.868, -4.8], [-33.4, -4.271], [-92.843, 12.673], [-133.009, 8.543], [-47.533, -4.887], [-43.449, -17.126], [-143.437, -7.6]]
    }, {
      command: 's',
      points: [[-179.387, -23.055], [-179.387, -23.055]]
    }],
    translate: [15609.599, 11730.528]
  });
});